import {
    useContext,
    useState,
    type FC
} from "react";
import type IButtonGroupMenuProps from "./type";
import {
    getButtonGroupMenuItemStyle
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    useAttachedGroupItem
} from "../../../attachedGroup/context";
import {
    DropdownMenuContext
} from "../../../dropdownMenu/context";
import DisclosureChevron from "../../../collapsible/internal/disclosureChevron";
import DropdownMenu from "../../../dropdownMenu";
import Button from "../../../button";

const ButtonGroupMenuIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => {
    const context = useContext(DropdownMenuContext);

    const {
        colors
    } = NCoreUIKitTheme.useContext(context?.customTheme);

    return <DisclosureChevron
        color={customColor ?? colors.content.icon[color]}
        customTheme={context?.customTheme}
        isOpen={!!context?.isOpen}
        size={size}
    />;
};

const ButtonGroupMenu: FC<IButtonGroupMenuProps> = ({
    isDisabled: isDisabledProp = false,
    isDefaultOpen = false,
    side = "bottom",
    customLocalize,
    align = "end",
    onOpenChange,
    customTheme,
    children,
    isOpen,
    testID,
    style,
    title
}) => {
    const {
        shapeConfigs,
        radiuses,
        borders
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const groupItem = useAttachedGroupItem();

    const [
        isFocused,
        setIsFocused
    ] = useState(false);

    const isDisabled = isDisabledProp || !!groupItem?.isDisabled;

    const itemStyle = getButtonGroupMenuItemStyle({
        shapeConfigs,
        isDisabled,
        groupItem,
        isFocused,
        radiuses,
        borders
    });

    const onPress = () => {};

    const onFocus = () => {
        setIsFocused(true);
    };

    const onBlur = () => {
        setIsFocused(false);
    };

    return <DropdownMenu
        customLocalize={customLocalize}
        isDefaultOpen={isDefaultOpen}
        onOpenChange={onOpenChange}
        customTheme={customTheme}
        isOpen={isOpen}
        align={align}
        title={title}
        side={side}
    >
        <DropdownMenu.Trigger
            customTheme={customTheme}
            style={[
                itemStyle.container,
                style
            ]}
            isDisabled={isDisabled}
        >
            <Button
                accessibilityLabel={title ?? localize("more-actions")}
                variant={groupItem?.groupVariant ?? "outline"}
                borderRadius={groupItem?.outerRadius}
                type={groupItem?.type ?? "neutral"}
                isPressScaleEnabled={false}
                icon={ButtonGroupMenuIcon}
                style={itemStyle.surface}
                customTheme={customTheme}
                isDisabled={isDisabled}
                size={groupItem?.size}
                spreadBehaviour="free"
                onPress={onPress}
                onFocus={onFocus}
                testID={testID}
                onBlur={onBlur}
            />
        </DropdownMenu.Trigger>
        {children}
    </DropdownMenu>;
};
export default ButtonGroupMenu;
